import { useState } from 'react';

export default function Hero() {
  const [imageError, setImageError] = useState(false);

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>

      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/30 blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-accent-100/20 blur-3xl translate-y-1/3 -translate-x-1/4 pointer-events-none"></div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 py-24 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line"></i>
              <span>热门影视 · 流畅不缓冲</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-5">
              苹果视频 - 免费高清影视在线观看平台
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-8">
              苹果视频汇集海量高清电影、电视剧资源，覆盖西瓜视频免费、免费视频网站91等热门频道，每日更新最新剧集和经典影片。无需注册，打开即看，全高清画质流畅播放零缓冲，让你随时随地免费享受影院级观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-movie-2-line text-primary-500 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">10万+</div>
                  <div className="text-xs text-foreground-500">影片资源</div>
                </div>
              </div>
              <div className="w-px h-8 bg-secondary-200 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-refresh-line text-accent-500 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">每日50+</div>
                  <div className="text-xs text-foreground-500">内容更新</div>
                </div>
              </div>
              <div className="w-px h-8 bg-secondary-200 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-speed-up-line text-secondary-500 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">零缓冲</div>
                  <div className="text-xs text-foreground-500">高清流畅</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>开始观看
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50 text-foreground-800 font-medium text-sm rounded-lg border-2 border-secondary-200 hover:border-primary-300 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-trophy-line mr-2"></i>热度榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            {!imageError ? (
              <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cinematic%20warm-toned%20entertainment%20visual%20with%20soft%20gradient%20lighting%2C%20abstract%20film%20reel%20and%20play%20button%20elements%2C%20modern%20streaming%20platform%20aesthetic%2C%20rich%20coral%20and%20amber%20color%20palette%2C%20clean%20minimalist%20design%2C%20smooth%20textures%2C%20digital%20entertainment%20concept&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                  alt="苹果视频在线观影平台 - 高清电影电视剧免费观看"
                  className="w-full h-full object-cover"
                  onError={() => setImageError(true)}
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/15 via-transparent to-accent-500/10 pointer-events-none"></div>
              </div>
            ) : (
              <div className="w-full aspect-[4/3] rounded-2xl bg-background-200 flex items-center justify-center">
                <div className="text-center text-foreground-400">
                  <i className="ri-movie-2-line text-5xl mb-3 block"></i>
                  <span className="text-sm">苹果视频</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}